import { EnrollmentInput, MFAChallengeInput, EnrollmentResponse, MFAMethod } from '@/services/mfa'
import { getClient } from './client'

const defaultErrorMessage = 'Invalid MFA Code. The code you entered is incorrect or has expired.'

/* Authenticator */
export const enrollAuthenticator = async ({ access_token }: Omit<EnrollmentInput, 'username' | 'phone_number'>): Promise<string | null> => {
  const body = { access_token }

  try {
    const client = getClient()
    const response = await client.post('/auth/mfa/associateSoftwareToken', body)
    return response?.data?.SecretCode || null
  } catch (error) {
    return null
  }
}

export const verifyEnrollmentAuthenticator = async ({ access_token, code }: Omit<MFAChallengeInput, 'username' | 'session'>): Promise<EnrollmentResponse> => {
  const body = { access_token, code }

  try {
    const client = getClient()
    const response = await client.post('/auth/mfa/verifyAndEnableMfa', body)

    if (response.status !== 200) {
      return { success: false, message: defaultErrorMessage }
    }

    return { success: true, message: 'Enrollment verified' }
  } catch (error) {
    return { success: false, message: defaultErrorMessage }
  }
}
/* Authenticator */

/* SMS */
export const enrollSMS = async ({ username, phone_number, access_token }: EnrollmentInput): Promise<{ session: string | null, sentTo: string | null }> => {
  const body = { mfa_type: MFAMethod.SMS, username, phone_number, access_token }

  try {
    const client = getClient()
    const response = await client.post('/auth/mfa/enableMfa', body)
    return { session: response?.data?.Session || null, sentTo: response?.data?.ChallengeParameters?.CODE_DELIVERY_DESTINATION || null }
  } catch (error) {
    return { session: null, sentTo: null }
  }
}

export const verifyEnrollmentSMS = async ({ username, session, code }: Omit<MFAChallengeInput, 'access_token'>): Promise<EnrollmentResponse> => {
  const body = { mfa_type: MFAMethod.SMS, username, session, code }

  try {
    const client = getClient()
    const response = await client.post('/auth/mfa/verify', body)
    if (response.status !== 200) {
      return { success: false, message: defaultErrorMessage }
    }

    return { success: true, message: 'Enrollment verified' }
  } catch (error) {
    return { success: false, message: defaultErrorMessage }
  }
}
/* SMS */

/* Email */
export const enrollEmail = async ({ username, access_token }: Omit<EnrollmentInput, 'phone_number'>): Promise<string | null> => {
  const body = { mfa_type: MFAMethod.Email, access_token, username }

  try {
    const client = getClient()
    const response = await client.post('/auth/mfa/enableMfa', body)
    return response?.data?.Session || null
  } catch (error) {
    return null
  }
}

export const verifyEnrollmentEmail = async ({ session, username, code }: Omit<MFAChallengeInput, 'access_token'>): Promise<EnrollmentResponse> => {
  const body = { session, username, code, mfa_type: MFAMethod.Email }

  try {
    const client = getClient()
    const response = await client.post('/auth/mfa/verify', body)

    if (response.status !== 200) {
      return { success: false, message: defaultErrorMessage }
    }

    return { success: true, message: 'Enrollment verified' }
  } catch (error) {
    return { success: false, message: defaultErrorMessage }
  }
}
/* Email */
